module.exports = __webpack_public_path__ + "img/JOB.32ddbc14.png";